export class Kmehrelement {

    public name = '';
    public value = '';
    protected $elements = [];

    fromJson(json: any): void {
    }
}
